import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormSelect, FormWrapper } from 'components/form';
import { useClaimPropertiesContext } from 'contexts/claimProperties';
import { useCachedClaimProperties } from 'hooks';

const { Option } = Select;

interface CurrencySelectProps {
  name: string;
  label: string;
  wrapStyles?: React.CSSProperties;
}

export const CurrencySelect = ({ name, label, wrapStyles }: CurrencySelectProps) => {
  const { t } = useTranslation();
  const { key: claimPropertiesKey } = useClaimPropertiesContext();
  const { data: claimProperties } = useCachedClaimProperties(claimPropertiesKey);

  return (
    <FormWrapper name={name} label={label} wrapStyles={wrapStyles}>
      <FormSelect
        allowClear
        placeholder={t('newClaim.partialClaim.secondClaim.claimCurrencyPlaceholder')}
        name={name}
        defaultValue="HKD"
      >
        {(claimProperties?.currencies ?? []).map(({ code }) => (
          <Option key={code}>{code}</Option>
        ))}
      </FormSelect>
    </FormWrapper>
  );
};
